import React from "react";
import PropTypes from "prop-types";

const YoutubeEmbed = ({embedId}) => {
  return (
    <div>
      <iframe
        className="w-[400px] h-[225px] xl:w-[960px] xl:h-[540px] md:w-[720px] md:h-[480px] sm:w-[640px] sm:h-[360px]"
        // width="720"
        // height="480"
        src={`https://www.youtube.com/embed/${embedId}`}
        title="Conheça a lavanderia que gera economia e praticidade"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </div>
  )
}

YoutubeEmbed.propTypes = {
  embedId: PropTypes.string.isRequired
};

export default YoutubeEmbed;
